import { render, staticRenderFns } from "./ReportInstructionsOther.vue?vue&type=template&id=48d0c84a&scoped=true"
import script from "./ReportInstructionsOther.vue?vue&type=script&lang=js"
export * from "./ReportInstructionsOther.vue?vue&type=script&lang=js"
import style0 from "./ReportInstructionsOther.vue?vue&type=style&index=0&id=48d0c84a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d0c84a",
  null
  
)

export default component.exports